module.exports = __webpack_public_path__ + "img/14022023.94de7de6.jpg";